import { React } from "react";
import "../App.css";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../auth";

const Login = () => {
	const { login } = useUserAuth();
	const navigate = useNavigate();
	const handleLogin = async (e) => {
		e.preventDefault();
		const email = e.target.login_email.value.trim();
		const password = e.target.login_password.value.trim();
		await toast
			.promise(login(email, password), {
				pending: "Logging in...",
			})
			.then(() => {
				navigate("/");
			});
	};

	return (
		<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/Reset-password-pana.svg?alt=media')`, backgroundSize: "600px", backgroundPosition: "left" }}>
			<div id="loginForm" className="loginForm">
				<div className="title-div">
					<h3>Sign In</h3>
				</div>
				<hr />
				<form onSubmit={handleLogin} className="form">
					<div className="form-groups">
						<div className="form-group">
							<input type="email" id="login_email" name="login_email" placeholder="Enter registered Email ID" autoComplete="off" required />
							<label>Email</label>
						</div>
						<div className="form-group">
							<input type="password" id="login_password" name="login_password" placeholder="Enter registered password" autoComplete="off" required />
							<label>Password</label>
						</div>
						<Link className="forgotpasswordlink" to="/forgotpassword">
							Forgot Password?
						</Link>
					</div>
					<div className="buttons">
						<button type="submit" id="login" className="btn">
							Login
						</button>
					</div>
				</form>
				<div className="options">
					<p>Don't have an account yet?</p>
					<Link className="optionlink" to="/register">
						Register
					</Link>
				</div>
			</div>
		</motion.section>
	);
};

export default Login;
